import { render, staticRenderFns } from "./userShow.vue?vue&type=template&id=3de68a41&scoped=true&"
import script from "./userShow.vue?vue&type=script&lang=js&"
export * from "./userShow.vue?vue&type=script&lang=js&"
import style0 from "./userShow.vue?vue&type=style&index=0&id=3de68a41&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de68a41",
  null
  
)

export default component.exports